import React, { useState } from 'react';
import api from '../api/axios';
import { useNavigate, Link } from 'react-router-dom';
import { Lock, Mail, Loader2, Eye, EyeOff } from 'lucide-react';
import { motion } from 'framer-motion';

/* ─── Ciseaux horizontal (pour la coupe sur le bouton) ─────────── */
const ScissorsCut = () => (
  <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Lame haute */}
    <path d="M17 12 L34 4.5" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
    {/* Lame basse */}
    <path d="M17 12 L34 19.5" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
    {/* Bras vers anneau haut */}
    <path d="M17 12 L11 6.5" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
    {/* Bras vers anneau bas */}
    <path d="M17 12 L11 17.5" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
    {/* Pivot */}
    <circle cx="17" cy="12" r="3.5" fill="white" />
    <circle cx="17" cy="12" r="1.8" fill="rgba(29,78,216,0.55)" />
    {/* Anneau haut */}
    <circle cx="5.5" cy="5.5"  r="5" stroke="white" strokeWidth="2.2" fill="none" />
    {/* Anneau bas */}
    <circle cx="5.5" cy="18.5" r="5" stroke="white" strokeWidth="2.2" fill="none" />
  </svg>
);

/* ─── Illustration ciseaux (panneau desktop gauche) ─────────────── */
const ScissorsPanel = () => (
  <svg width="100%" height="100%" viewBox="0 0 380 540" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="190" cy="265" r="172" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
    <circle cx="190" cy="265" r="128" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
    <path d="M42 38 C62 118 38 185 58 258 C78 332 48 385 68 455"  stroke="rgba(255,255,255,0.13)" strokeWidth="2" fill="none" strokeLinecap="round" />
    <path d="M338 55 C313 132 338 195 315 270 C292 345 320 396 300 466" stroke="rgba(255,255,255,0.10)" strokeWidth="2" fill="none" strokeLinecap="round" />
    <path d="M142 18 C120 92 150 150 130 220 C110 290 134 342 120 410" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <path d="M248 22 C270 96 246 155 266 225 C286 295 263 345 276 415" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <path d="M316 145 L318.5 138 L321 145 L328 147.5 L321 150 L318.5 157 L316 150 L309 147.5 Z" fill="rgba(255,255,255,0.5)" />
    <path d="M55 308 L57.5 302 L60 308 L66 310.5 L60 313 L57.5 319 L55 313 L49 310.5 Z"         fill="rgba(255,255,255,0.38)" />
    <path d="M188 488 L190.5 481 L193 488 L200 490.5 L193 493 L190.5 500 L188 493 L181 490.5 Z" fill="rgba(255,255,255,0.28)" />
    <circle cx="78"  cy="128" r="3"   fill="rgba(255,255,255,0.42)" />
    <circle cx="306" cy="192" r="2"   fill="rgba(255,255,255,0.32)" />
    <circle cx="348" cy="370" r="3.5" fill="rgba(255,255,255,0.26)" />
    <circle cx="52"  cy="418" r="2"   fill="rgba(255,255,255,0.30)" />
    <circle cx="276" cy="88"  r="2.5" fill="rgba(255,255,255,0.36)" />
    <circle cx="102" cy="486" r="2"   fill="rgba(255,255,255,0.20)" />
    <g transform="translate(190, 280) rotate(-18)">
      <path d="M-6 -18 L-55 -168 L-44 -174 L5 -18 Z"  fill="rgba(255,255,255,0.96)" />
      <path d="M-52 -166 L-6 -20" stroke="rgba(255,255,255,0.28)" strokeWidth="1" />
      <path d="M6 -18 L50 -150 L62 -144 L14 -18 Z"    fill="rgba(255,255,255,0.82)" />
      <path d="M60 -146 L13 -18" stroke="rgba(255,255,255,0.20)" strokeWidth="1" />
      <path d="M-26 -92 L24 -80" stroke="rgba(255,255,255,0.20)" strokeWidth="1" strokeDasharray="4 4" />
      <circle cx="0" cy="0" r="15" fill="white" />
      <circle cx="0" cy="0" r="10" fill="rgba(18,46,158,0.45)" />
      <circle cx="0" cy="0" r="4"  fill="rgba(255,255,255,0.88)" />
      <circle cx="-3" cy="-3" r="1.5" fill="rgba(255,255,255,0.6)" />
      <path d="M-7 15 L-43 102" stroke="rgba(255,255,255,0.90)" strokeWidth="12" strokeLinecap="round" />
      <path d="M-43 102 L-55 122" stroke="rgba(255,255,255,0.70)" strokeWidth="7"  strokeLinecap="round" />
      <path d="M7 15 L43 102"  stroke="rgba(255,255,255,0.76)" strokeWidth="12" strokeLinecap="round" />
      <path d="M43 102 L55 122" stroke="rgba(255,255,255,0.56)" strokeWidth="7"  strokeLinecap="round" />
      <ellipse cx="-53" cy="153" rx="37" ry="44" stroke="rgba(255,255,255,0.90)" strokeWidth="8" fill="none" />
      <ellipse cx="-53" cy="153" rx="20" ry="24" stroke="rgba(255,255,255,0.18)" strokeWidth="2" fill="none" />
      <ellipse cx="53"  cy="153" rx="37" ry="44" stroke="rgba(255,255,255,0.76)" strokeWidth="8" fill="none" />
      <ellipse cx="53"  cy="153" rx="20" ry="24" stroke="rgba(255,255,255,0.15)" strokeWidth="2" fill="none" />
    </g>
  </svg>
);

/* ─── CSS global pour les animations ───────────────────────────── */
const ANIM_CSS = `
  @keyframes ss-cut {
    0%   { left: -50px; opacity: 1; }
    62%  { left: calc(100% + 16px); opacity: 1; }
    63%  { left: -50px; opacity: 0; }
    100% { left: -50px; opacity: 0; }
  }
  .ss-scissors-cut {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    animation: ss-cut 4.5s ease-in-out infinite;
    pointer-events: none;
    z-index: 10;
  }
`;

/* ─── Page Login ────────────────────────────────────────────────── */
const Login = () => {
  const [email,        setEmail]        = useState('');
  const [password,     setPassword]     = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading,      setLoading]      = useState(false);
  const [error,        setError]        = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await api.post('/auth/login', { email, password });
      const { token, user } = response.data;
      const role = user.role;
      localStorage.setItem('token', token);
      localStorage.setItem('role', role);
      localStorage.setItem('userName', user.prenom);
      if (role === 0)      navigate('/super-admin-dashboard');
      else if (role === 1) navigate('/dashboard');
      else if (role === 5) navigate('/employee/dashboard');
      else                 setError('Accès non autorisé.');
    } catch (err) {
      setError(err.response?.data?.message || 'Email ou mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <style>{ANIM_CSS}</style>

      {/* ══ PANNEAU GAUCHE — illustration (desktop seulement) ═════════ */}
      <div
        className="hidden lg:flex lg:w-5/12 flex-col items-center justify-between py-12 px-10 relative overflow-hidden"
        style={{ background: 'linear-gradient(150deg, #0b1955 0%, #1a3496 45%, #1f58d4 100%)' }}
      >
        <div style={{ position:'absolute', top:'-120px', left:'-100px', width:440, height:440, borderRadius:'50%', background:'radial-gradient(circle, rgba(255,255,255,0.04) 0%, transparent 70%)', pointerEvents:'none' }} />
        <div style={{ position:'absolute', bottom:'-100px', right:'-80px', width:360, height:360, borderRadius:'50%', background:'radial-gradient(circle, rgba(255,255,255,0.035) 0%, transparent 70%)', pointerEvents:'none' }} />

        <div className="relative z-10 text-center w-full">
          <h2 className="text-2xl font-black tracking-tight text-white">Sama<span style={{ opacity:0.72 }}>Salon</span></h2>
          <p style={{ color:'rgba(165,195,255,0.7)', fontSize:10, fontWeight:800, textTransform:'uppercase', letterSpacing:'0.18em', marginTop:4 }}>Espace professionnel</p>
        </div>

        <div className="relative z-10 w-full flex-1 flex items-center justify-center" style={{ minHeight:0 }}>
          <ScissorsPanel />
        </div>

        <div className="relative z-10 text-center">
          <p style={{ color:'rgba(200,220,255,0.85)', fontWeight:700, fontSize:15, lineHeight:1.5, maxWidth:220, margin:'0 auto' }}>L'art de la coiffure, géré avec style.</p>
          <div style={{ width:36, height:2, background:'rgba(255,255,255,0.28)', margin:'12px auto 0', borderRadius:2 }} />
        </div>
      </div>

      {/* ══ PANNEAU DROIT / PLEINE PAGE MOBILE ════════════════════════ */}
      <div
        className="flex-1 flex items-center justify-center p-6 min-h-screen relative overflow-hidden"
        style={{ background: 'var(--login-bg)' }}
      >
        {/* Fond bleu + ciseaux fantôme sur mobile/tablette, slate-50 sur desktop */}
        <style>{`
          :root { --login-bg: #f8fafc; }
          @media (max-width: 1023px) {
            :root { --login-bg: linear-gradient(150deg, #0b1955 0%, #1a3496 50%, #1f58d4 100%); }
          }
        `}</style>

        {/* Ciseaux en filigrane sur fond mobile */}
        <div className="lg:hidden" style={{ position:'absolute', inset:0, pointerEvents:'none', overflow:'hidden' }}>
          <ScissorsPanel />
        </div>

        {/* Décorations desktop */}
        <div className="hidden lg:block" style={{ position:'absolute', top:'-60px', right:'-60px', width:220, height:220, borderRadius:'50%', background:'radial-gradient(circle, rgba(59,130,246,0.06) 0%, transparent 70%)', pointerEvents:'none' }} />
        <div className="hidden lg:block" style={{ position:'absolute', bottom:'-50px', left:'-50px', width:180, height:180, borderRadius:'50%', background:'radial-gradient(circle, rgba(99,102,241,0.05) 0%, transparent 70%)', pointerEvents:'none' }} />
        <div className="hidden lg:block" style={{ position:'absolute', top:'48%', left:'6%', width:10, height:10, borderRadius:'50%', background:'#bfdbfe', opacity:0.55, pointerEvents:'none' }} />

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="w-full max-w-sm relative"
          style={{
            background: '#fff',
            borderRadius: '2.5rem',
            padding: '2rem 2rem',
            border: '1px solid rgba(241,245,249,0.8)',
            boxShadow: '0 20px 60px rgba(0,0,0,0.12), 0 4px 16px rgba(0,0,0,0.06)',
          }}
        >
          <div style={{ position:'absolute', top:0, left:'10%', right:'10%', height:3, background:'linear-gradient(90deg, transparent, #3b82f6, #6366f1, transparent)', borderRadius:'0 0 4px 4px' }} />

          <div className="text-center mb-8">
            <div className="inline-block p-3.5 bg-blue-50 rounded-3xl mb-3">
              <h1 className="text-2xl font-black tracking-tight leading-none">
                <span className="text-slate-900">Sama</span>
                <span style={{ background:'linear-gradient(135deg,#2563eb,#4f46e5)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>Salon</span>
              </h1>
            </div>
            <p className="text-slate-400 font-bold text-[10px] uppercase tracking-widest">Connexion</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-4">
            {error && (
              <motion.div
                initial={{ x: -8, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                className="bg-red-50 text-red-600 p-3 rounded-2xl text-xs font-bold border border-red-100 flex items-center gap-2"
              >
                <div className="w-1.5 h-1.5 bg-red-600 rounded-full animate-pulse flex-shrink-0" />
                {error}
              </motion.div>
            )}

            <div className="space-y-1.5">
              <label className="text-[10px] font-black text-slate-400 uppercase ml-1 tracking-wider">Email</label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300" size={16} />
                <input
                  type="email" required
                  className="w-full pl-10 pr-4 py-3.5 bg-slate-50 border border-transparent rounded-2xl focus:bg-white focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 outline-none transition-all font-bold text-slate-700 text-sm"
                  placeholder="nom@exemple.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="space-y-1.5">
              <div className="flex justify-between items-center px-1">
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-wider">Mot de passe</label>
                <Link to="/forgot-password" className="text-[10px] font-black text-blue-500 hover:text-blue-600 uppercase tracking-tight transition-colors">
                  Mot de passe oublié ?
                </Link>
              </div>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300" size={16} />
                <input
                  type={showPassword ? 'text' : 'password'} required
                  className="w-full pl-10 pr-10 py-3.5 bg-slate-50 border border-transparent rounded-2xl focus:bg-white focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 outline-none transition-all font-bold text-slate-700 text-sm"
                  placeholder="••••••••"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />
                <button type="button" onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-300 hover:text-slate-500 transition-colors">
                  {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            {/* Bouton avec ciseaux animés sur mobile */}
            <div className="relative mt-1 rounded-2xl overflow-hidden">
              <button
                type="submit" disabled={loading}
                className="w-full text-white font-black py-4 flex items-center justify-center gap-2 disabled:opacity-70 active:scale-[0.98]"
                style={{ background:'linear-gradient(135deg,#2563eb,#3b82f6)', boxShadow:'0 12px 28px rgba(59,130,246,0.35)', transition:'all 0.25s', borderRadius:'1rem' }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 16px 36px rgba(59,130,246,0.48)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 12px 28px rgba(59,130,246,0.35)'; e.currentTarget.style.transform = ''; }}
              >
                {loading
                  ? <><Loader2 className="animate-spin" size={18} /><span>Identification…</span></>
                  : 'Se connecter'}
              </button>

              {/* Ciseaux qui coupent — mobile/tablette uniquement, masqué si loading */}
              {!loading && (
                <div className="lg:hidden ss-scissors-cut">
                  <ScissorsCut />
                </div>
              )}
            </div>
          </form>

          <div className="mt-6 pt-6 border-t border-slate-100 text-center space-y-2">
            <p className="text-slate-500 text-sm font-medium">
              Pas encore de compte ?{' '}
              <Link to="/inscription" className="text-blue-600 font-black hover:underline">Créer mon salon</Link>
            </p>
            <p className="text-slate-400 text-[10px] font-bold uppercase tracking-widest">
              &copy; 2026 SamaSalon
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Login;
